import { Button, Link } from '@mui/joy';
import { logout } from '../../controllers/auth';
import { useDispatchContext, useStateContext } from '../../Store/Context';

const NavBar = () => {

	const {isLoggedIn} = useStateContext();
	const dispatch = useDispatchContext();

	async function handleLogout() {
		await logout(dispatch);
	}

	return (
		<div className='w-full flex justify-between items-center px-8 md:px-28 py-4' style={{background: "255 255 255 0.4", backdropFilter: "blur(6px)", position: "sticky", top: "0px"}}>
			<div>
				<a href='/'>
					<img style={{width: "50px"}} src='/webmark.png' alt='Webmark logo' />
				</a>
			</div>
			{!isLoggedIn&&<div>
				<Link sx={{marginX: "10px"}} href={"/signin"}>
					<Button variant='outlined'>
						Login
					</Button>
				</Link>
				<Link sx={{marginX: "10px"}} href={"/signup"}>
					<Button>
						Signup
					</Button>
				</Link>
			</div>}
			{
				isLoggedIn&&<div>
					<Button variant='outlined' onClick={handleLogout}>
						Logout
					</Button>
				</div>
			}
		</div>
	)
}

export default NavBar;